import { getApolloClient } from 'owa-apollo';
import { ApplyConversationActionContext } from 'owa-mail-triage-action-utils';
import getEwsRequestDateString from 'owa-mail-triage-action-utils/lib/getEwsRequestDateString';
import DisposalType from 'owa-service/lib/contract/DisposalType';
import RequestOptions from 'owa-service/lib/RequestOptions';
import {
    DeleteConversationDocument,
    DeleteConversationMutation,
} from './graphql/__generated__/deleteConversationMutation.interface';
import { MailboxInfo } from 'owa-client-ids';

type DeleteConversationResult = DeleteConversationMutation['deleteConversation'];

/**
 * The service which calls the ApplyConversationAction with delete parameters.
 * @param conversationContexts the conversation contexts to be deleted
 * @param contextFolderId  the folder where the conversations will be deleted from
 * @param disposalType the disposal type
 */
export default async function deleteConversationService(
    conversationContexts: ApplyConversationActionContext[],
    contextFolderId: string,
    disposalType: DisposalType,
    mailboxInfo: MailboxInfo,
    options?: RequestOptions
): Promise<DeleteConversationResult> {
    const conversationSnapShots = conversationContexts.map(context => {
        return {
            id: context.conversationId,
            messagesAsOf: getEwsRequestDateString(context.conversationLastSyncTimeStamp),
        };
    });
    const client = await getApolloClient();
    const result = await client.mutate({
        variables: {
            conversations: conversationSnapShots,
            disposalType: disposalType,
            folderId: contextFolderId,
            mailboxInfo: mailboxInfo,
        },
        context: {
            requestOptions: options,
        },
        mutation: DeleteConversationDocument,
    });

    return result?.data?.deleteConversation;
}
